import $ from 'jquery'
import Cookies from 'js-cookie'

// eslint-disable-next-line no-unused-vars
import { Modal, Collapse } from 'bootstrap'

// eslint-disable-next-line no-undef
const object = nrjObject

const jsContainer = () => {
  if ($('.js-container').length) {
    const bodyWidth = $('body').outerWidth()
    $('.js-container').css({
      width: bodyWidth,
      marginLeft: `calc(${-bodyWidth / 2}px + 50%)`,
    })
  }
}

$(window).bind('resize', jsContainer).trigger('resize')

$('.vn-btn-terms button').on('click', function (e) {
  e.preventDefault()
  const button = $(this)
  const href = button.attr('data-url')

  window.location.href = href
})

$('.go-top').on('click', function () {
  document.getElementsByTagName('html')[0].scrollIntoView({ behavior: 'smooth' })
})

$('.entry-header__scroll').on('click', function () {
  $('.entry-content--target')[0].scrollIntoView({ behavior: 'smooth' })
})

$('.vn-excerpt__more').on('click', function () {
  const button = $(this)
  const button_parent = button.parents('.vn-excerpt')

  if (button_parent.hasClass('vn-excerpt--active')) {
    button.html(object.readmore)
  } else {
    button.html(object.readless)
  }

  button_parent.toggleClass('vn-excerpt--active')
})

$('#psr-button').on('click', function () {
  $('#psr-button').toggleClass('psr-button--active')
  $('#psr-modal').toggleClass('psr-modal--active')

  Cookies.set('stickyPSQActive', 1)
})

$('#psr-close-modal').on('click', function () {
  $('#psr-button').toggleClass('psr-button--active')
  $('#psr-modal').toggleClass('psr-modal--active')

  Cookies.set('stickyPSQActive', 0)
})

$('a[href="#cookies"]').on('click', (e) => {
  e.preventDefault()
  window.openAxeptioCookies()
})

